import breakpoints from './partials/breakpoints';

export const mqRoles = {
  desktop_extra_large: (width: number) => width >= breakpoints.desktopXl,
  desktop_large: (width: number) =>
    width >= breakpoints.desktopL && width < breakpoints.desktopXl,
  desktop_medium: (width: number) =>
    width >= breakpoints.desktopM && width < breakpoints.desktopL,
  desktop_small: (width: number) =>
    width >= breakpoints.desktopS && width < breakpoints.desktopM,
  mobile_medium: (width: number) =>
    width >= breakpoints.mobileM && width < breakpoints.tablet,
  mobile_small: (width: number) => width < breakpoints.mobileM,
  tablet: (width: number) =>
    width >= breakpoints.tablet && width < breakpoints.desktopS
};

export const checkMediaQuery = (mediaQuery: (width: number) => boolean) =>
  mediaQuery(window.innerWidth);

export const loadMediaQueries = () => ({
  isDesktop:
    checkMediaQuery(mqRoles.desktop_small) ||
    checkMediaQuery(mqRoles.desktop_medium) ||
    checkMediaQuery(mqRoles.desktop_large) ||
    checkMediaQuery(mqRoles.desktop_extra_large),
  isDesktopExtraLarge: checkMediaQuery(mqRoles.desktop_extra_large),
  isDesktopLarge: checkMediaQuery(mqRoles.desktop_large),
  isDesktopMedium: checkMediaQuery(mqRoles.desktop_medium),
  isDesktopSmall: checkMediaQuery(mqRoles.desktop_small),
  isMobile:
    checkMediaQuery(mqRoles.mobile_medium) ||
    checkMediaQuery(mqRoles.mobile_small),
  isMobileMedium: checkMediaQuery(mqRoles.mobile_medium),
  isMobileSmall: checkMediaQuery(mqRoles.mobile_small),
  isTablet: checkMediaQuery(mqRoles.tablet)
});
